import * as CaseApi from 'saas/pco/cases/api';
import { normalize } from 'normalizr';
import * as schema from 'saas/pco/cases/api/schema';
import { getIsFetching, getCaseSites } from '../reducers/sites';
import { push, replace } from 'react-router-redux';

export const FETCH_SITES = 'case.FETCH_SITES';
export const FETCH_SITES_SUCCESS = 'case.FETCH_SITES_SUCCESS';
export const SELECT_SITE = 'case.SELECT_SITE';
export const UNSELECT_SITE = 'case.UNSELECT_SITE';
export const ADD_SITE = 'case.ADD_SITE';
export const UPDATE_SITE = 'case.UPDATE_SITE';

const requestSites = () => ({
  type: FETCH_SITES,
});

const receiveSites = response => ({
  type: FETCH_SITES_SUCCESS,
  response: normalize(response, schema.arrayOfCaseSites),
});

export const fetchSites = siteCase => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestSites());

  // Request interventions fetching then planning
  return CaseApi.getSitesByCase(siteCase)
    .then(response => dispatch(receiveSites(response)))
    .then(res => {
      // Redirecting to first site if exists
      const first = res.response.result[0];
      if (first) {
        dispatch(push(`/sites/${first}`));
      }
    });
};

export const selectSite = site => (dispatch, getState) => {
  const selected = {
    ...site,
    new: true,
  };

  dispatch({
    type: SELECT_SITE,
    response: normalize(selected, schema.caseSite),
  });

  // Redirecting to selected site
  dispatch(push(`/sites/${site.id}`));
};

export const unselectSite = site => (dispatch, getState) => {
  const siteIndex = getCaseSites(getState()).findIndex(
    s => s.id.toString() === site.id.toString()
  );

  dispatch({
    type: UNSELECT_SITE,
    site: site.id,
  });

  const sites = getCaseSites(getState());
  if (sites.length === 0) {
    // Redirecting to index if it's last one
    dispatch(replace('/'));
  } else {
    const nextTabSite = siteIndex === 0 ? sites[0] : sites[siteIndex - 1];

    if (nextTabSite) {
      dispatch(push(`/sites/${nextTabSite.id}`));
    }
  }
};

export const addSite = site => ({
  type: ADD_SITE,
  site,
});

export const updateSite = (site, values) => {
  const merged = {
    ...site,
    ...values,
  };

  var response = normalize(merged, schema.caseSite);

  return {
    type: UPDATE_SITE,
    response: response,
  };
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/actions/sites.js